import { Component, AfterViewInit, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from "@angular/animations";
import { MenuService } from "./menu-service";
import { first } from "rxjs/operators";
import { Employee } from "src/app/parametrage/core/model/employee/employee";
import { KeycloakService } from "src/app/core/services/auth/keycloak.service";
import { EmployeeService } from "src/app/parametrage/core/service/employee.service";

@Injectable({
  providedIn: "root",
})
@Component({
  selector: "app-nav-bar-horizontal",
  templateUrl: "./nav-bar-horizontal.component.html",
  styleUrls: ["./nav-bar-horizontal.component.scss"],
})
export class NavBarHorizontalComponent implements AfterViewInit {
  currentEmployee: Employee = new Employee();

  MyPermissions: string[];

  menus: any = [];
  menus_l2: any = [];
  menus_l3: any = [];
  menus_l4: any = [];
  current_menu_l4: String = null;

  constructor(
    private _router: Router,
    private _keycloakService: KeycloakService,
    public horizontalbarservice: MenuService,
    private _employeeService: EmployeeService
  ) {
    this.getCurrentEmployee();
    this.menus = horizontalbarservice.getMenuList();
    this.MyPermissions = _keycloakService.getAccessPermissions();
  }

  ngAfterViewInit() {
    //cacher menu L4 quand le menu change
    setInterval(() => {
      if (localStorage.getItem("current_menu_header_changed") == "true") {
        this.current_menu_l4 = null;
        localStorage.setItem("current_menu_header_changed", "false");
      }
    }, 100);
  }

  getCurrentEmployee() {
    this._employeeService.getCurrentEmployee().subscribe(
      (data) => {
        this.currentEmployee = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  refreshHeader() {
    let header_id = localStorage.getItem("current_menu_header");

    this.menus.forEach((element) => {
      element.current_header = header_id;
    });

    return this.menus;
  }

  clearMenu(codeMenu) {
    let header_id = localStorage.getItem("current_menu_header");

    this.refreshMenuL2(header_id);
    this.refreshMenuL3(header_id);
    this.refreshMenuL4(header_id, null);

    this.activeMenuL1(codeMenu);
  }

  refreshMenuL2(code) {
    this.menus_l2 = this.horizontalbarservice.getMenuList_l2();
    this.menus_l2.forEach((element) => {
      element.current_header = code;
    });

    this.activeMenuL1(code);

    return this.menus_l2;
  }

  activeMenuL1(code) {
    this.menus.forEach((element) => {
      if (element.code == code) {
        element.active = "#3F51B5";
      } else {
        element.active = "";
      }
    });
  }

  activeMenuL2(code) {
    this.menus_l2.forEach((element) => {
      if (element.code == code) {
        element.active = "active";
      } else {
        element.active = "";
      }
    });
  }

  refreshMenuL3(code) {
    this.menus_l3 = this.horizontalbarservice.getMenuList_l3();
    this.menus_l3.forEach((element) => {
      element.current_header = code;
      this.activeMenuL2(code);
    });
    return this.menus_l3;
  }

  activeMenuL3(code) {
    this.menus_l3.forEach((element) => {
      if (element.code == code) {
        element.active = { "font-weight": "bold" };
      } else {
        element.active = "";
      }
    });
  }

  refreshMenuL4(code, title) {
    this.menus_l4 = this.horizontalbarservice.getMenuList_l4();

    this.menus_l4.forEach((element) => {
      element.current_header = code;
      this.activeMenuL3(code);
    });

    //vérifier si menu l4 existe
    let menu = this.menus_l4.find((e) => e.header_id === code);
    if (menu != null) {
      this.current_menu_l4 = menu.title;
    }
    if (title == null) {
      this.current_menu_l4 = null;
    }

    return this.menus_l4;
  }

  clearCurrentMenuL4() {
    this.current_menu_l4 = null;
  }

  redirection(menu) {
    this.current_menu_l4 = menu.title;
    this._router.navigate([menu.Url]);
  }
}
